import React, { Component } from 'react'
import Grid from "../../../Utils/Grid";
import { TableHeaderColumn } from "react-bootstrap-table";
import { standardActions } from "../../../Utils/Grid/StandardActions";
import Link from "react-router-dom/es/Link";
import Card from "Utils/Cards/Card"
import Header from "Utils/Grid/Header";
import './RolesList.css';

export default class RolesList extends Component {
    componentDidMount() {
        const { listar, page } = this.props;
        listar(page);
    }


    render() {
        const { listar: onPageChange, onSortChange, eliminar } = this.props;
        const { data, loader, page } = this.props;
        return (
            <div className="mb-4 col-12 roles-list-container">
                <Card
                    icon="configuraciones_activo.png"
                    titulo="ROLES"
                    subtitulo="Del sistema">
                    <Header to="rol/crear" textBtn="CREAR ROL" {...this.props} />
                    <Grid hover striped data={data} loading={loader} page={page} onPageChange={onPageChange}>
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width='100px'
                            dataFormat={standardActions({ editar: "rol", eliminar })}
                        />
                        <TableHeaderColumn
                            isKey
                            dataField="rol_name"
                            dataSort
                        >
                            ROL
                        </TableHeaderColumn>
                    </Grid>
                </Card>
            </div>
        )
    }
}
